{
  "00945c89f76b547f": "Qualification",
  "487347e074fb8050": "Failed to submit rate request",
  "7da032c39f057ad2": "Duplicate requests within the last {{lookBackDays}} days are not permitted.",
  "917e144e4bc3da89": "Submit request",
  "9f8669337c8da10b": "Rate request submitted. Your CSM will follow up within 1 business day."
}
